// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Removes outliers from an array and returns a new array.
 * @param {Array<number>}
 * @returns {Array<number}
 */
export const removeOutliers = data => {
  var { q1, q3 } = getQuartiles(data)
  var interquartileRange = q3 - q1
  var maxLower = q1 - interquartileRange * 1.5,
    maxUpper = q3 + interquartileRange * 1.5
  // Filter out outliers
  return data.filter(val => {
    return val >= maxLower && val <= maxUpper
  })
}

/**
 * @typedef Quartiles
 * @property {number} q1
 * @property {number} q2
 * @property {number} q3
 *
 * Get quartiles from an array of data points.
 * @param {Array<number>} dataPoints
 * @returns {Quartiles}
 */
export const getQuartiles = function(dataPoints) {
  const sortNumerically = function(a, b) {
    if (a < b) return -1
    if (a > b) return 1
    return 0
  }

  dataPoints = dataPoints.slice(0).sort(sortNumerically)

  const { midValue: q2, lowerSet, upperSet } = getMidPoint(dataPoints)

  const { midValue: q1 } = getMidPoint(lowerSet)
  const { midValue: q3 } = getMidPoint(upperSet)

  return { q1, q2, q3 }

  function getMidPoint(dataPoints) {
    var q2Index, q2, q2_1, q2_2, lowerSet, upperSet
    if (dataPoints.length % 2 == 1) {
      // Is an odd number of values
      q2Index = Math.floor(dataPoints.length / 2)
      q2 = dataPoints[q2Index]
      lowerSet = dataPoints.slice(0, q2Index)
      upperSet = dataPoints.slice(q2Index + 1)
    } else {
      // Is an even number of values
      q2Index = dataPoints.length / 2
      q2_1 = dataPoints[q2Index - 1]
      q2_2 = dataPoints[q2Index]
      q2 = (q2_1 + q2_2) / 2
      lowerSet = dataPoints.slice(0, q2Index)
      upperSet = dataPoints.slice(q2Index)
    }
    return {
      lowerSet,
      upperSet,
      midValue: q2,
    }
  }
}

/**
 * Same as calculateMedianWeight but removes outliers before calculating
 * the weight. See `calculateMedianWeight`
 */
export const calculateMedianWeightExcludingOutliers = (value, range) => {
  range = removeOutliers(range)
  // If it was removed it was an outlier
  // TODO If we're computing this a lot can do this as part of the
  // removeOutliers code
  if (range.includes(value) === false) {
    if (value < range[0]) return 0
    else return 1
  }
  return calculateMedianWeight(value, range)
}

/**
 * Rank how successful a mission is between 0 and 1. 1 being the most successful
 * compared to it's peers and 0 being the worst compared to its peers.
 * @param {number} needle The value we are weighting
 * @param {Array<number>} haystack The range of values to calculate the median
 * from. IMPORTANT: This must include the needle value and it must be in sorted
 * order.
 * @return {number} A value between 0 and 1
 */
export const calculateMedianWeight = (needle, haystack) => {
  var valueIndex = 0,
    found = false
  for (var i = haystack.length - 1; i >= 0; i--) {
    if (haystack[i] == needle) found = true
    if (haystack[i + 1] !== undefined && haystack[i] > haystack[i + 1])
      throw new Error(
        'Encountered a haystack value that was out of numeric order.',
      )
    if (haystack[i] <= needle) {
      valueIndex = i
      break
    }
  }
  if (!found) throw new Error('The needle was not found in the haystack.')
  return (1 / (haystack.length - 1)) * valueIndex
}

/**
 * @typedef WeightedValue
 * @property {number} value The value
 * @property {number} weight The weight/importance of the value
 *
 * Calculate a weighted average.
 * @param {Array<WeightedValue>} weightedValues
 * @returns {number}
 */
export const calculateWeightedAverage = weightedValues => {
  var totals = weightedValues.reduce(
    (cumulativeTotal, weightedValue) => {
      cumulativeTotal.value += weightedValue.value
      cumulativeTotal.weight += weightedValue.weight
      return cumulativeTotal
    },
    { value: 0, weight: 0 },
  )

  return totals.value / totals.weight
}



// WEBPACK FOOTER //
// ./src/shared/stats.js